@if (_debug()) {
    <span>{{samenwerking.werkmodus()}}</span>&nbsp;
}
[{{sessie.projectcode()}}]: {{dlModel.titel}}
@if(_debug()) {
   &nbsp;<span>{{usernaam()}}</span>&nbsp;
}
@if (opslag.userprefix()) {
    <span>({{opslag.userprefix()}})</span>
}
@if (samenwerking.heeftMeekijkers()) {
    &nbsp;<span class="fa-solid fa-eye"[title]="samenwerking.clientnames()"></span>
}
